import { ChevronIcon } from "@paguelofacil/pf-components";

export const ButtonBack = ({ handleBack }) => {
    return (
        <button
            type="button"
            onClick={handleBack}
            style={{ backgroundColor: "transparent", border: "none", cursor: "pointer" }}
        >
            <ChevronIcon direction="left" color="#515A69" />
        </button>
    );
};
